import baseGet from "./component-library281.mjs";
import baseSet from "./component-library282.mjs";
import castPath from "./component-library283.mjs";
function basePickBy(object, paths, predicate) {
  var index = -1, length = paths.length, result = {};
  while (++index < length) {
    var path = paths[index], value = baseGet(object, path);
    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}
export {
  basePickBy as default
};
